// Functions for,
// My accounts, Details, Orders - Page

(function(MODULE, $, undefined) {

    MODULE.myAccount = (function() {
        function _subModule() {

            var _this = this;
            /* Store this to avoid scope conflicts */

            // local caching in case required, examples below

            function getIds(idType, controllerURL) {
                var myId = "";
                if (controllerURL) {
                    var temp = controllerURL;
                    if (temp.indexOf(idType) != -1) {
                        temp = temp.substring(temp.indexOf(idType));
                        var tokens = temp.split("&");
                        var tokens2 = tokens[0].split("=");
                        myId = tokens2[1];
                    }
                    if (myId.indexOf("#") != -1) {
                        var tokens1 = myId.split("#");
                        myId = tokens1[0];
                    }
                }
                return myId;
            }

            function getItemDetails(orderId, getDataTextAttr) {
                var storeId = getIds("storeId", location.href);
                var catalogId = getIds("catalogId", location.href);
                var newparams = {};
                newparams.orderId = orderId;
                newparams.storeId = storeId;
                newparams.catalogId = catalogId;
                $.ajax({
                    type: 'POST',
                    url: "OrderItemDetailsView",
                    data: newparams,
                    success: function(result) {
                        $("#wcs_orderHistory_viewDetails_" + orderId).html(result);
                        $("#wcs_orderHistory_viewDetails_" + orderId).attr("ajaxLoaded", "true");
                        $(".wcs-myOrder-status-details[data-text=" + getDataTextAttr + "]").toggleClass("wcs-hide");
                        $(".wcs-orderHistory-viewDetails[id=" + getDataTextAttr + "]").toggleClass("wcs-hide");
                        $(".wcs-myOrder-details-content.wcs-myOrder-history-content[data-attr=" + getDataTextAttr + "]").toggleClass("wcs-hide");
                        /*  For Tool tip in item details section loaded after ajax*/
                        show_light_box();
                        $('.wcs-icon.wcs-info.wcs-tip').hover(function(e) {
                            $(this).children('p').toggleClass("wcs-hidden");
                            var middle_height = $(this).children("p:not('.wcs-hide')").height() / 2;
                            var notification_box_top = -middle_height + 12;
                            $(this).children('p').css('top', notification_box_top);
                            $(this).children('p').children('span.wcs-notification-arrow').css('top', middle_height - 10);
                        });

                        /*  For Cancel, Modify and Re-order links in item details section loaded after ajax*/
                        $(".wcs-myorders-cancel-order-link").off('click').on('click', cancelOrderSubmitHandler);
                        $(".wcs-myorders-re-order-link").off('click').on('click', function() {
                            var getOrderId = $(this).attr('data-order');
                            $("#wcs-re-order-form input[name=fromOrderId]").val(getOrderId);
                            $("#wcs-re-order-form input[name=reOrderId]").val(getOrderId);
                            $("#wcs-re-order-form").submit();
                        });
                        openLinksInNewTab();
                        if($(".D_Payment_ViewPickupBtnOverlay").length > 0){
                        	deliveryObj.viewOrderDetailsAjax();
                        }
                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                    }
                });
            }

            window.reset_editDetail_form = function() {
                $('#wcs-save').removeClass('wcs-btn-disable');
                //$('#wcs-month-load').val($('#wcs-dob_month').val());
                //$('#wcs-day-load').val($('#wcs-dob_day').val());
                //$('#wcs-year-load').val($('#wcs-dob_year').val());
                $("#wcs-dob-error").hide();
                $("#wcs-dob-subscribe-error").hide();
                $('div.wcs-months-dd').find('.wcs-red-border').removeClass('wcs-red-border');
                /*$('#wrapper4val').val($('#wrapper4val').data('default'));
                 $('#wrapper5val').val($('#wrapper5val').data('default'));
                 $('#wrapper6val').val($('#wrapper6val').data('default'));
                 */
                $("#wcs-account-edit-form .wcs-row").removeAttr('style');
                $("#wcs-account-edit-form .wcs-error-message").removeClass('wcs-show');
                $("#wcs-account-edit-form input").removeClass('ui-state-error h5-active');
                $("#wcs-account-edit-form .wcs-custom-dropdown-container").removeClass('ui-state-error');
            };

            function myAccountFunctions() {
                /* Shipped order left side height fix */
                var getDataAttr = $(".wcs-status-shipped-rightContent").attr('data-attr');
                var getDataText = $(".wcs-status-shipped-leftContent").attr('data-text');
                if (getDataText == getDataAttr) {
                    $(".wcs-status-shipped-leftContent").addClass('wcs-trackOrder-shipped');
                }

                $(".wcs-account-switchDetails").off('click').on('click', function() {
                    reset_editDetail_form();
                    $('#emailSignUp-inactive').parent().addClass('wcs-hide');
                    $('#emailSignUp').parent().removeClass('wcs-hide');
                    $("#wcs-account-changeDetails, #wcs-account-edit-form, #wcs-account-editDetails, #wcs-account-preferences").toggleClass('wcs-hide');
                    $(".wcs-myPreferences .wcs-label-check").toggleClass('wcs-label-check-edit');
                    this.init = function() {
                        //overAllFormValidation();
                        return this; /*this refere to MODULE.subModule*/
                    };
                });

                $(".wcs-accont-cancelEdit").off('click').on('click', function() {
                    var getFirstName = $("#wcs-account-firstName").html();
                    var getLastName = $("#wcs-account-lastName").html();
                    var getPhoneNumber = $("#wcs-account-phoneNumber").html();
                    var getDOB = $("#wcs-account-dob").html();
                    var tokens;
                    if ("" !== getDOB) {
                        tokens = $.trim(getDOB).split("/");

                        // RB-26896: recompose birth date on DOB select
                        dob_values = $.trim(getDOB).split("-");
                        if(dob_values.length === 3) {
                            $('#wrapper4val').val(parseInt(dob_values[0]));
                            $('#wrapper5val').val(parseInt(dob_values[1]));
                            $('#wrapper6val').val(parseInt(dob_values[2]));
                        }
                    }
                    if ($("#emailSignUp").is(":checked")) {
                        $('#emailSignUp').attr('checked', 'checked').parent().addClass('wcs-c-on');
                    } else {
                        $('#emailSignUp').removeAttr('checked').parent().removeClass('wcs-c-on');
                    }
                    $('#emailSignUp-inactive').parent().removeClass('wcs-hide');
                    $('#emailSignUp').parent().addClass('wcs-hide');
                    $("#wcs-account-edit-form input[name='firstName']").val(getFirstName);
                    $("#wcs-account-edit-form input[name='lastName']").val(getLastName);
                    $("#wcs-account-edit-form input[name='phone1']").val(getPhoneNumber);
                    if ("" !== tokens) {
                        $('#wcs-month-load').val(tokens[0]);
                        $('#wcs-day-load').val(tokens[1]);
                        $('#wcs-year-load').val(tokens[2]);
                        //$("#wcs-account-edit-form input[name='month']").val(tokens[1]);
                        //$("#wcs-account-edit-form input[name='day']").val(tokens[2]);
                        //$("#wcs-account-edit-form input[name='year']").val(tokens[0]);
                    } else {
                        $('#wcs-month-load').val($('#wcs-dob_month').val());
                        $('#wcs-day-load').val($('#wcs-dob_day').val());
                        $('#wcs-year-load').val($('#wcs-dob_year').val());
                    }
                    $("#wcs-account-changeDetails, #wcs-account-edit-form, #wcs-account-editDetails, #wcs-account-preferences").toggleClass('wcs-hide');
                    $(".wcs-myPreferences .wcs-label-check").toggleClass('wcs-label-check-edit');
                    $("#wcs-account-edit-form input[type='radio']").removeClass('ui-state-valid');
                    $("#wcs-account-edit-form input[type='radio']").parent().removeClass('wcs-r-on');
                    $("#wcs-account-edit-form input[type='radio'][checked='checked']").addClass('ui-state-valid');
                    $("#wcs-account-edit-form input[type='radio'][checked='checked']").parent().addClass('wcs-r-on');
                });

                window.cancel_link = function() {
                    $('.wcs-quick-buy-lightbox .wcs-myOrder-status-link, .wcs-quick-buy-lightbox .wcs_close_lightBox').off('click').on('click', function() {
                        $(this).closest('.wcs-quick-buy-lightbox').find('.wcs-close-btn').trigger('click');
                        $(this).closest('.wcs-quick-buy-lightbox').find('.wcs-row').find('input').removeClass('ui-state-error');
                    });
                };
                cancel_link();

                $(".wcs-myOrder-status-details").off('click').on('click', function() {
                    var getDataTextAttr = $(this).attr('data-text');
                    var idAttr = $(this).attr('id');
                    var orderId = $(this).parent().parent().attr("orderId");
                    var ajaxLoadedForOrder = $("#" + getDataTextAttr).attr("ajaxLoaded");
                    if (idAttr == "wcs-myOrder-viewDetails" && ajaxLoadedForOrder == 'false') {
                        getItemDetails(orderId, getDataTextAttr);
                    } else {
                        $(".wcs-myOrder-status-details[data-text=" + getDataTextAttr + "]").toggleClass("wcs-hide");
                        $(".wcs-orderHistory-viewDetails[id=" + getDataTextAttr + "]").toggleClass("wcs-hide");
                        $(".wcs-myOrder-details-content.wcs-myOrder-history-content[data-attr=" + getDataTextAttr + "]").toggleClass("wcs-hide");
                        if($(".D_Payment_ViewPickupBtnOverlay").length > 0){
                        	deliveryObj.viewOrderDetailsAjax();
                        }
                    }
                    prevOrderId = $("#printPrevOrderId").val();
                    if (prevOrderId === "") {
                        $("#printPrevOrderId").val(orderId);
                        $("#wcs_print_preview").attr("id", "wcs_print_preview_" + orderId);
                    }
                    else {
                        $("#wcs_print_preview_" + prevOrderId).attr("id", "wcs_print_preview_" + orderId);
                        $("#printPrevOrderId").val(orderId);
                    }

                });

                $('.wcs-myOrder-status-details').parent('.wcs-myOrder-status-title').unbind('click').click(function(e) {
                    if (e.target == this) {
                        $(this).find('.wcs-myOrder-status-details:visible').click();
                    }
                });

                $(".wcs-order-history-circle").off('click').on('click', function() {
                    var getDataAttr = $(this).parent().attr('data-attr');
                    $(".wcs-myOrder-status-viewDetails[data-text=" + getDataAttr + "]").trigger('click');
                });

                $('.js-dob-select').on('change', function(){
                    var dobWrapper = $(this).closest('.rb-fieldrow');
                    var day = $('#wrapper4val').val();
                    var month = $('#wrapper5val').val();
                    var year = $('#wrapper6val').val();
                    var age = calculateAgeUsingDate(month,day,year);
                    var cutOffAgeStringValue = $('#wcs-dob').attr('data-age-limit') || $('#wcs-dob_validation').val();
                    var cutOffAge = parseInt(cutOffAgeStringValue) || 18;
                    if (age < cutOffAge) {
                        dobWrapper.removeClass('rb-validrow').addClass('rb-invalidrow');
                    } else {
                        dobWrapper.removeClass('rb-invalidrow').addClass('rb-validrow');
                    }
                });

                $('.wcs-account-edit-save').off('click').on('click', function() {
                        if (!$(this).hasClass('wcs-btn-disable') && $(this).attr("disabled") != "disabled") {
                            ///debugger;
                            //Formating Date OF Birth- WCS
                            $('#dateOfBirth').remove();
                            var day = $('#wrapper4val').val();
                            var month = $('#wrapper5val').val();
                            var year = $('#wrapper6val').val();
                            var age = calculateAgeUsingDate(month,day,year);
                            var cutOffAgeStringValue = $('#wcs-dob').attr('data-age-limit') || $('#wcs-dob_validation').val();
                            var cutOffAge = parseInt(cutOffAgeStringValue) || 18;

                            $("#wcs-dob-subscribe-error").removeClass("wcs-show").hide();
                            if (age < cutOffAge) {
                            	$("#wcs-dob-error").addClass("wcs-show").show();
                            } else {
                            	$("#wcs-dob-error").removeClass("wcs-show").hide();
                            }

                            if (day === "" || month === "" || year === "")
                            {
                                $('#wcs-dob').remove();
                                //NO ACTION
                            }
                            else {
                                var dob = year + "-" + month + "-" + day;
                                $('#wcs-dob').val(dob);
                            }

                            //Checking If the Email Pref CheckBox is checked-WCS
                            var emailPref = $('#wcs-EmailPrefVal').val();
                            var emailTS = $('#curentTime').val();
                            var userType = $('#userType').val();
                            if (emailPref != "null") {
                                if ($('#emailSignUp').is(':checked')) {
                                    $('#emailSignUp-inactive').attr('checked', 'checked').parent().addClass('wcs-c-on');
                                    $('#emailTimeStamp').val(emailTS);
                                    $('#emailSubs').val(1);
                                }
                                else {
                                    $('#emailSignUp-inactive').removeAttr('checked').parent().removeClass('wcs-c-on');
                                    $('#emailTimeStamp').val(emailTS);
                                    $('#emailSubs').val(0);
                                }
                            }
                            else {
                                if ($('#emailSignUp').is(':checked')) {
                                    $('#emailSignUp-inactive').attr('checked', 'checked').parent().addClass('wcs-c-on');
                                    $('#emailTimeStamp').val(emailTS);
                                    $('#emailSubs').val(1);
                                }
                                else {
                                    $('#emailSignUp-inactive').removeAttr('checked').parent().removeClass('wcs-c-on');
                                    $('#emailTimeStamp').remove();
                                    $('#emailSubs').remove();
                                }
                            }

                            if ("#profilingConsent") {
                            	 if ($('#profilingConsent_check').is(':checked')) {
                            		 $('#profilingConsent').val(1);
                            	 } else {
                            		 $('#profilingConsent').val(0);
                            	 }
                            }

                            var isDOBValid = !$('.js-rb-custom-select').hasClass('rb-invalidrow');

                            //Submit Form
                            if (!$('#wcs-dob-error').is(':visible') && isDOBValid) {
                                var formObj = $('#wcs-account-edit-form');
                                formObj.find('input:text.required:visible').trigger('blur');
                                show_error(formObj.find('input.ui-state-error'));
                                if (formObj.find('.wcs-dropdown-validation').length) {
                                    show_dropDown_error_message(formObj.find('.wcs-dropdown-validation'));
                                }

                                if (!formObj.find('.ui-state-error').length) {
                                    $('#wcs-account-edit-form').submit();
                                } else {
                                    $('#wcs-save').addClass('wcs-btn-disable');
                                }

                            }
                        }
                });


                $(".wcs-myorders-re-order-link").off('click').on('click', function() {
                    var getOrderId = $(this).attr('data-order');
                    $("#wcs-re-order-form input[name=fromOrderId]").val(getOrderId);
                    $("#wcs-re-order-form input[name=reOrderId]").val(getOrderId);
                    $("#wcs-re-order-form").submit();
                });
            }

            //Fix for RB-8652
            window.zipCodeCAValidation = function() {
            	if($("#zip_code").length > 0) {
	                if ($("#zip_code").attr('name') == 'billingZipCode') {
	                    var billingCountry = $('#billing-country').val();
	                    if (billingCountry.toUpperCase() != 'CA') {
	                        return true;
	                    }
	                }
                  if ($('#zip_code').val() !== '') {
                    trimmedZip = $('#zip_code').val().replace(/ /g, '');
                    $('#zip_code').val(trimmedZip.substring(0, 3) + ' ' + trimmedZip.substring(3, 6));
                  }
            	}
                return true;
            };

            $(".wcs-en_CA #delivery_information_form,.wcs-fr_CA #delivery_information_form").submit(function() {
                return zipCodeCAValidation();
            });


            function alignOrderStatusRows() {
                $('div.wcs-myOrder-details-content').each(function() {
                    var orderRows = $(this).find('div.wcs-myOrder-rows');
                    $(this).find('div.wcs-myOrder-status-section').each(function(index) {
                        if (orderRows[index]) {
                            const myOrderItemStatusSectionTitleClassName = $(this)[index].className;
                            const isMyOrderItemStatusSectionTitle = myOrderItemStatusSectionTitleClassName && myOrderItemStatusSectionTitleClassName.includes('wcs-myOrder-status-section-title--wrapper');
                            if (isMyOrderItemStatusSectionTitle) {
                                $(this).height(orderRows.eq(index).height() - 20);
                            } else {
                                $(this).height(orderRows.eq(index).height() + 25);
                            }
                        }
                    });
                });
            }

            // window.myAccountResizeOverlayInit = function() {
            //     var overlay = $('div.wcs-fadeout-full');
            //     $('div.wcs-quick-buy-lightbox input, div.wcs-quick-buy-lightbox select').off('focusout.overlay').on('focusout.overlay', function() {
            //         window.setTimeout(function() {
            //             overlay.height($(document).height());
            //         }, 10);
            //     });

            // };
            /**
             * Init call
             */
            this.init = function() {
                myAccountFunctions();
                if ($('div.wcs-myOrder-details-content').length > 0) {
                    alignOrderStatusRows();
                    $(window).on('load', function() {
                        //alignOrderStatusRows();
                    });
                }
                /* guest login & create account function */
                $('.wcs-user-register-wrapper .wcs-close-btn').off('click').on('click', function() {
                    Assign_value($('#userEmail'), $('#guestUserEmail'));
                    $('.wcs-guest-checkout-container').removeClass('wcs-hide');
                    $('.wcs-user-register-wrapper').addClass('wcs-hide');
                    $('.wcs-create-account-link').css('visibility','visible');

                    hide_form_errors('user_register_form');
                    //$('.wcs-guest-checkout-container').find('.wcs-row').attr('style', '').find('.wcs-error-message').removeClass('wcs-show');
                    //$('.wcs-guest-checkout-container').find('.wcs-row').find('#guestUserEmail').removeClass('ui-state-error');
                    //formValidation_onBlur();
                    $('.wcs-note-red').hide();
                });
                $('.wcs-create-account-link').off('click').on('click', function() {
					$("form").find("input[type=submit]").removeClass("wcs-btn-disable").attr("disabled",false);
                    Assign_value($('#guestUserEmail'), $('#userEmail'));
                    Assign_value($('#guestUserEmail'), $('#email1'));
                    $('.wcs-user-register-wrapper').removeClass('wcs-hide');
                   // $('.wcs-guest-checkout-container').addClass('wcs-hide');
                   // $('.wcs-create-account-link').css('visibility','hidden');
                   // $('.wcs-user-register').find('.wcs-row').attr('style', '').find('.wcs-error-message').removeClass('wcs-show');
                    //$('.wcs-user-register').find('.wcs-row').find('#userEmail').removeClass('ui-state-error');
                    //$('.wcs-user-register').find('.wcs-row').find('#password').removeClass('ui-state-error');
                    ///$('.wcs-user-register').find('.wcs-row').find('#confirm_password').removeClass('ui-state-error');
                    //formValidation_onBlur();
                    $('.wcs-note-red').hide();
					$cached.forgot_password_form.removeClass("wcs-hide wcs-show").hide();
                });

                /*maintain the state for checkout page*/
                if ($("#wcs-createAcct-flag").val()) {
                    $('.wcs-user-register-wrapper').removeClass('wcs-hide');
                    //$('.wcs-guest-checkout-container').addClass('wcs-hide');
                }
                //myAccountResizeOverlayInit();
                /*$('#payment_confirm_alipay, #payment_confirm_payease').bind('click.wcspay', function() {
                    var that = this;
                    window.setTimeout(function() {
                        $(that).addClass('wcs-btn-disable').attr('disabled', 'disabled');
                    }, 50);

                });*/

                //delete order: show deletion result message in overlay
                if (Rayban && Rayban.OverlayManager) {
                    var $trigger = $('.order-cancel-result-trigger');
                    if ($trigger.size() > 0) {
                        (new Rayban.OverlayManager()).setupOverlay($trigger[0]);
                        $trigger[0].RBOverlay.open();
                        $('.rb-overlay-close-btn').click(function(e) {
                            $trigger[0].RBOverlay.close();
                        });
                    }
                }

                return this; /*this refere to MODULE.subModule*/
            };

            return this.init(); /*this refere to MODULE.subModule.init()*/
        }
        return new _subModule(); /*creating a new object of subModule rather then a funtion*/
    }());


    $(function() {
        /*
         * showing forgot password container on click of forgot password
         * link in login register page
         */
        window.show_forgot_password_form = function() {
            $('form[name="forgot_password_form"]').removeClass("wcs-hide wcs-show").show();
            $('div.wcs-forget-password-success').addClass('wcs-hide');
            $('div.wcs-forget-password-elements').removeClass('wcs-hide');
        };

        /*
         * showing the forgot password forms and changing the color to
         * the clicked link in login register page
         */
        $("#forgot_password").off("click").on("click", function() {
            show_forgot_password_form();
            $(this).css('color', '#666');
            //formValidation_onBlur();
			$('.wcs-user-register-wrapper').addClass('wcs-hide');
            if($("#loginEmail").val() !== "") {
                $("#forgotPassword_email").val($("#loginEmail").val());
                $("#forgotPassword_email").blur();
            }
        });

    	$('#user_login_form').find('#wcs_logon_password').off("keyup");
    	$('#user_login_form').find('#wcs_logon_password').on('input', function(){

    		var pwd_pattern = /^.*(?=.{7})(?=.*\d)(?=.*[a-zA-Z]).*$/;
    		var valid_pwd = pwd_pattern.test($(this).val());

    		if(valid_pwd && $('#user_login_form').find('#loginEmail').hasClass('ui-state-valid') ) {
    			$('#login_submit').addClass("ui-state-valid");
    		} else if(!valid_pwd) {
    			$('#login_submit').removeClass("ui-state-valid");
    		}
    	});

    });
    var items = $('.x-my-orders__item')
    items.each(function(){
        var deliveryDates = $(this).children('.x-my-orders__item__delivery-date')
        deliveryDates.each(function(index){
            if(index > 0) {
                var deliveryDate = deliveryDates.get(index-1);
                var currentText = $(this).text() ? $(this).text().replace(/\s/g,'') : "";
                var deliveryDateText = $(deliveryDate).text() ? $(deliveryDate).text().replace(/\s/g,'') : "";
                if( currentText === deliveryDateText){
                   $(this).remove()
                }
            }
        });
    })

    if (items.length > 1) {
      var deliveryLabel = $('#deliveryLabel').val() ? $('#deliveryLabel').val().split("1. ")[1] : "Delivery";
      var ofLabel = $('#ofLabel').val()
      items.each(function(){
          var deliveryDates = $(this).children('.x-my-orders__item__delivery-date')
          deliveryDates.each(function(index){
              if(!$(this).prev().hasClass('x-my-orders__item__delivery-number')){
                  $('<div class="x-my-orders__item__delivery-number">'+deliveryLabel+' '+(index+1)+' '+ofLabel+' '+deliveryDates.length+':</div>').insertBefore($(this))
              }
          });
      });
    }


    window.openChatWindowDirect = function() {
        show_full_fadeout_1();
        var $chatDiv = $('#wcs-support-chat-direct-popup');
        var wdh = 0.5 * $(window).width();
        var hgt = 0.75 * $(window).height();
        var fr=$chatDiv.css({
            height: hgt,
            width: wdh
        }).find('iframe').css({
            height: hgt,
            width: wdh
        });
    	fr.attr('src', fr.data('src'));
        display_center_1($chatDiv);
        $chatDiv.show();
    };
    var overlay = $('div.wcs-fadeout-full');
    $('#delivery_information_form_add #wcs-addAddr, .wcs-details-addNewAddress.wcs-modal-box').off('click').on('click', function() {
		if($('#delivery_information_form_add .wcs-error-message.wcs-inline-block').length > 0){
			window.setTimeout(function() {
				overlay.height($(document).height());
			}, 10);
		}
	});
	$('#delivery_information_form_add input.required').off('change').on('change', function() {
		if($('#delivery_information_form_add .wcs-error-message.wcs-inline-block').length > 0){
			window.setTimeout(function() {
				overlay.height($('#wcs_myDetails_addHomeAddress').height()+$('.wcs-myDetails-lightbox-form-button').height());
			}, 10);

		}
	});

    $('#order-cancel-result-overlay .rb-btn-del-order').click(function(){
        $('#order-cancel-result-overlay').removeClass('active');
    });


    /**
     * Check to evaluate whether 'MODULE' exists in the global namespace - if not, assign window.MODULE an object literal
     */
}(window.rayban = window.rayban || {}, jQuery));

function redirectCartUrl(){
    var orderId = $('#OrderId').val();
    var shipModeId = $('#shipModeId2').val();
    var url = $('#expRedirectUrl').val();
    var params = {};
    params.orderId = orderId;
    params.shipModeId = shipModeId;
    $.ajax({
        type: 'POST',
        url: 'AjaxShipChargeUpdate',
        data: params,
        async: false,
        success: function() {
            $(location).attr('href', url);
        }
    });
}

$(".wcs-myorders-cancel-order-link").click(function() {
    var getOrderIdLB = $('#wcs_myOrder_cancelOrder').attr('data-order-lighbox');
    var getOrderAmount = $('#wcs_myOrder_cancelOrder').attr('data-amout-lighBox');
    var country = $("#county").val();

    //validation
    var $cancellationReason = $('.wcs-myOrders-cancellation-reason');
    if($('#rb-input-cancelReason').length > 0){
        $cancellationReason = $('#rb-input-cancelReason')
    }
    var checkValidation = function() {
        var isValid = $cancellationReason.val() !== '';
        if(isValid){
            $('.order-cancellation-message').hide();
            $cancellationReason.parent().parent().toggleClass('rb-invalidrow', !isValid);

        }else{
            $cancellationReason.parent().parent().toggleClass('rb-invalidrow', !isValid);
            $('.order-cancellation-message').show();
        }
       return isValid;
    }
    if (!$cancellationReason.data('change-event-attached')) {
        $cancellationReason.data('change-event-attached', true);
        $cancellationReason.on('change', function() {
            checkValidation();
        });
    }

    //submit hidden form
    if (checkValidation()) {
        var $form = $('#wcs-cancel-order-form');
        if ($("a[data-forcerefund='true']").length > 0) {
            $form.find("input[name=forcedCancel]").val("true");
            $form.find("input[name=forcedCancelWithRefund]").val("true");
        }
        $form.find("input[name=orderId]").val(getOrderIdLB);
        $form.find("input[name=cancelReason]").val($cancellationReason.val());
        $form.submit();
    }
});


$('#expShpCart').off('click').on('click', function() {
    redirectCartUrl();
});

if($('select#js-my-orders-filter').length > 0) {
    $('select#js-my-orders-filter').niceSelect();
}


$(function() {
    //RB-43815
    if (!$("body").hasClass("wcs-en_US")) {
        $('.nice-select.x-my-orders__filter li.option').click(function(){
            var label = $(this).html();
            var filterValue = $(this).data('value');
            if (filterValue === 'all') {
                $('.js-my-orders-item').show();
            } else {
                $('.js-my-orders-item').hide();
                $('[data-order-status="' + filterValue + '"]').show();
            }
            // $('.nice-select.x-my-orders__filter').removeClass('open');
            $(".current").html(label);
            $('.list').hide();
        });
    }
});
    
$(function() {
    //RB-43815
        if (!$("body").hasClass("wcs-en_US")) {
        $('.current').click(function(){
                $('.list').show();
        });
    }
});

function initFacebookLoginFunctionality() {
    const storeId = $('#storeId').val();
    //check url
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname;
    }
    function selectOptionsIterator(str, elementsArray) {
        elementsArray.each(function(index, el) {
            let currentEl = $(el),
                dataStr = currentEl.data('value');

            if(dataStr < 10) {
                dataStr = '0' + dataStr;
            }

            if(str == dataStr) {
                currentEl.trigger('click');
            }

        });
    }

    //helper functions for data setting
    function setBirthData(dataStr) {
        let customSelectHolder = $('.js-rb-custom-select-ddmmyyyy');
        if(!customSelectHolder.length) {
            return false;
        }

        let splitedData = dataStr.split('/'),
            customSelectOptionsArr = [];

        customSelectOptionsArr.push($('.js-day-option'));
        customSelectOptionsArr.push($('.js-month-option'));
        customSelectOptionsArr.push($('.js-year-option'));

        $.each(splitedData, function(i, el) {
            selectOptionsIterator(el, customSelectOptionsArr[i]);
        });
    }

    function existEmailHandler(reloginUrl, lastStepMSG) {
        let message = $('.existing-user-message'), link = message.find('.redirect-link');
        lastStepMSG.hide();
        message.show();
        $('.wcs-or-account-register').hide();
        link.off().on('click', function() {
            logoutFB();
            window.location.href = reloginUrl;
        });
    }

    function setDataToForm(data, form, url, token, ageBan, existEmail) {
        let lastStepMsg = $('.last-step-msg');
        //show age ban message
        if(ageBan) {
            Rayban.analytics.facebookLoginError();
            $('.age-ban-message').show();
        }else {
            $('.fb-login-btn-holder, .wcs-register-subtitle, .paragraph').hide();
            const user = data;
            //remove password fields if user uses FB login
            form.find('input[type="password"]').closest('.rb-fieldrow').remove();
            //show date of birth for all stores
            form.find('.custom-select-holder').removeClass('hidden');
            //insert flag input for BE side
            form.prepend('<input type="hidden" name="confirmation"  value="true" />');
            //add class for validation changing
            form.addClass('fb-login');
            //set data to input fiels
            for (var key in user) {
                let inputTag = null;
                if(key === 'email') {
                    inputTag = form.find('input[type="email"]');
                } else if (key === 'birthday') {
                    setBirthData(user[key]);
                } else {
                    inputTag = form.find('input[name="'+ key +'"]');
                }

                if(inputTag) {
                    inputTag.val(user[key]);
                    inputTag.trigger('change');
                }
            }

            if(existEmail) {
                existEmailHandler(existEmail, lastStepMsg);
            }else {
                lastStepMsg.show();
            }

            form.off().on('submit', function(e) {
                e.preventDefault();

                tealium_data2track.push({
                    id: 'Click',
                    Tracking_Type: 'hiddenaction',
                    data_element_id: 'X_X_RegisterForm_Register',
                });

                const dataObj = collectData(form, token, true);

                sendAJAX(dataObj, url, function(data) {
                    console.log(data, 111);
                    if(data.email) {
                        setStorageData(data);
                        existEmailHandler(data.email, lastStepMsg);
                        return false;
                    }

                    if($('#pageName').val() === 'CheckoutLogon') {
                        if(!data.availableUserData && data.redirecturl) {
                            Rayban.analytics.facebookDeliveryLoginSuccess(true);
                            location.reload();
                            return false;
                        }
                    }else {
                        if(data.redirecturl) {
                            window.location.href = data.redirecturl;
                        }
                    }
                });
            });
        }
    }

    function setStorageData(dataFromServer) {
        const userData = {
            availableUserData: dataFromServer.availableUserData,
            missingParameters: dataFromServer.missingParameters,
            ageBan: dataFromServer.age,
            existEmail: dataFromServer.email
        }
        localStorage.setItem('userFB', JSON.stringify(userData));
    }

    function logoutFB() {
        localStorage.removeItem('userFB');
        FB.api('/me', function(response) {
            if(!response.error) {
                FB.logout();
            }
        });
    }

    function sendAJAX(requestData, urlStr, callback) {
        $.ajax({
            type: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            url: urlStr,
            data: JSON.stringify(requestData),
            dataType: 'json',
            success: function(data) {
                callback(data);
            },
            error: function(error) {
                console.log(error);
                logoutFB();
            }
        });
    }

    function collectData(formEl, token, flag) {
        const dataArr = formEl.serializeArray(),
            dataObj = {
                authorizationProvider: 'facebook',
                accessToken: token
            };

        dataArr.forEach(function(currElem) {
            let name = currElem.name;
            if(name !== 'logonId' && name !== 'logonPassword' && name !== 'logonEmail') {
                dataObj[name] = currElem.value;
            }
        });

        dataObj.pageName = $('#pageName').val();

        if(flag) {
            dataObj.confirmation = true;
            dataObj.logonEmail = formEl.find('input[type="email"]').val();
        }

        return dataObj;
    }

    function sendTokeToServer(apiResponse) {
        let token = null, pageForm;
        const authResponse = apiResponse.authResponse,
            page = $('#pageName').val(),
            registrationForm = $('#user_register_form'),
            loginForm = $('#user_login_form');

        registrationForm.length ? pageForm = registrationForm : pageForm = loginForm;

        if(authResponse) {
            token = authResponse.accessToken;
        }

        if(apiResponse.status === 'connected' && token && page === 'Login and Register' || page === 'CheckoutLogon') {

            let existUserFBData = localStorage.getItem('userFB');
            const urlString = window.location.origin + '/wcs/resources/store/'+ storeId + '/loginidentity/oauth_validate';

            if(existUserFBData && registrationForm.length) {
                let modifiedObj = JSON.parse(existUserFBData);
                //if user has an age ban (show error message only)
                if(modifiedObj.ageBan) {
                    setDataToForm(null, null, null, null, true);
                }else if (modifiedObj.existEmail) {
                    setDataToForm(modifiedObj.availableUserData, registrationForm, urlString, token, false, modifiedObj.existEmail);
                } else {
                    //LAST FB REGISTRATION STEP
                    setDataToForm(modifiedObj.availableUserData, registrationForm, urlString, token);
                }
            }else {
                const loginData = collectData(pageForm, token);
                sendAJAX(loginData, urlString, function(data) {
                    if(page === 'CheckoutLogon') {
                        if(!data.availableUserData && data.redirecturl) {
                            Rayban.analytics.facebookDeliveryLoginSuccess(true);
                            location.reload();
                            return false;
                        }else {
                            let FBFormContainer = $('.fb-register-form-container'),
                                FBForm = FBFormContainer.find('.fb-register-form');
                            pageForm.closest('.checkout-login-section').hide();
                            FBFormContainer.removeClass('wcs-hidden');
                            if(data.age) {
                                setDataToForm(null, null, null, null, true);
                            }else if(data.email) {
                                setDataToForm(data.availableUserData, FBForm, urlString, token, false,  data.email);
                            }else {
                                setDataToForm(data.availableUserData, FBForm, urlString, token);
                            }
                        }
                    }else {
                        if(!localStorage.getItem('userFB')) {
                            setStorageData(data);
                            //if user has an age ban (show error message only)
                            if(registrationForm.length && data.age) {
                                setDataToForm(null, null, null, null, true);
                            }else if(registrationForm.length && data.email) {
                                setDataToForm(data.availableUserData, registrationForm, urlString, token, false,  data.email);
                            }else if(registrationForm.length && data.missingParameters) {
                                setDataToForm(data.availableUserData, registrationForm, urlString, token);
                            }else {
                                window.location.href = data.redirecturl;
                            }
                        }
                    }
                });
            }
        }
    }

    function getApplicationID() {
        let url = window.location.origin + '/wcs/resources/store/'+ storeId + '/loginidentity/oauth',
            params = {
                authorizationProvider: 'facebook'
            };

        sendAJAX(params, url, function(data) {
            if(!data.clientId) {
                console.error('empty id parameter!!!!!');
                return false;
            }

            //FB API initialization
            window.fbAsyncInit = function() {
                console.log('FB Init......');

                FB.init({
                appId      : data.clientId, //need to take this info from storeconfig
                status     : true, // check login status
                cookie     : true, // enable cookies to allow the server to access the session
                xfbml      : true  // parse XFBML
                });

                $('.fb-custom-btn').off().on('click', function() {
                    FB.login(sendTokeToServer, {scope: 'email,user_birthday'});
                });

                var pageNameStr = $('#pageName').val();
                if (pageNameStr === 'Login and Register') {
                    FB.getLoginStatus(sendTokeToServer, true);
                } else {
                    if(pageNameStr === 'MyDetails' && localStorage.getItem('userFB')) {
                        Rayban.analytics.facebookLoginSuccess(true);
                    }
                    //delete cache and localStorage data
                    setTimeout(function() {
                        logoutFB();
                    }, 2000);
                }
            };

            // Load the SDK Asynchronously
            (function(d){
                var js, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement('script'); js.id = id; js.async = true;
                js.src = "//connect.facebook.net/en_US/all.js";
                ref.parentNode.insertBefore(js, ref);
            }(document));
        });
    }

    getApplicationID();
}

//initCustomSelect
function initCustomSelect() {
    let customSelectContainer = $('.js-rb-custom-select-ddmmyyyy');

    $('body').on('click', function(e) {
        if(!$(e.target).closest('.js-rb-custom-select-ddmmyyyy').length) {
            customSelectContainer.find('[class*="-dropdown"]').addClass('wcs-hide');
        }
    });

    function getMonth(lang, month) {
        const date = new Date(2009, month - 1, 10);
        return date.toLocaleString(lang, { month: 'long' });
    }

    customSelectContainer.find('.dob-month li').each(function() {
        const lang = $('html').attr('lang');
        const value = $(this).data('value');
        if (value) {
            $(this).text(value +'-' + getMonth(lang, value));
        }
    });

    customSelectContainer.find('.rb-select-wrapper').off().on('click', function() {
        $(this).find('select').trigger('focus');
        $(this).find('[class*="-dropdown"]').toggleClass('wcs-hide');
    });

    customSelectContainer.find('.day-value, .month-value, .year-value').off().on('click', function() {
        var selectEl = $(this).next();
        selectEl.trigger('focus');
        selectEl.next().toggleClass('wcs-hide');
    });

    customSelectContainer.find('li').off().on('click', function (event) {
        var clickedEL = $(this),
            clickedELValue = clickedEL.data('value'),
            wrapper = clickedEL.closest('.rb-select-wrapper'),
            select = wrapper.find('select'),
            optionEl = select.find('option'),
            valueContainer = select.next(),
            dropDown = valueContainer.next(),
            triggerEventsArr = ['change','blur','click'];

        //set value in valueContainer
        valueContainer.text(clickedELValue);
        //set value in select options
        optionEl.val(clickedELValue).attr('selected','selected');
        dropDown.addClass('wcs-hide');
        $.each(triggerEventsArr, function(i, el) {
            select.trigger(el);
        });
    });
}

//Facebook login functionality
$( document ).ready(function() {
    if(window.wcs_config.facebookLogin.toLowerCase() === "true"){
        initFacebookLoginFunctionality();
    }
    if ($('#pageName').val() === 'CheckoutLogon') {
        initCustomSelect();
    }

  $('.fb-register-form input[type="submit"]').off().on('click',function(e) {
    e.preventDefault();
    var isAgreeExist = $('#agreeConcent').length > 0;
    var isAgreeChecked = $('#agreeConcent').prop('checked') || false;
    var dateOfBirthEl = $('input[name="dateOfBirth"]');
    var validDateOfBirth = dateOfBirthEl.length > 0 ? !!dateOfBirthEl.val() && !dateOfBirthEl.parent().hasClass('rb-red-fg') : true;
    var inputsArr = ['#userFName', '#userLName', '#userEmail'];
    var form = $(this).closest('form');
    var validFlag = true;

    $.each(inputsArr, function(i, el) {
        var input = form.find(el);
        var parentEl =  input.parent()
        if(!input.val()) {
            parentEl.removeClass('rb-validrow');
            parentEl.addClass('rb-invalidrow');
            validFlag = false;
        }
    });

    if(!validDateOfBirth) {
        form.find('.js-rb-custom-select').addClass('rb-invalidrow');
        validFlag = false;
    }

    if (validFlag && isAgreeExist && isAgreeChecked){
        form.submit();
    }
    else if (validFlag && isAgreeExist == false)  {
        form.submit();
    }
    else {
        $("#agreeConcent").parent().addClass('rb-invalidrow');
    }
  });

    $('#user_login_form').submit(function () {
        localStorage.removeItem('cartSaved');
        localStorage.removeItem('ch_cartSaved');
        tealium_data2track.push({
            id: 'Click',
            Tracking_Type: 'hiddenaction',
            data_element_id: 'X_X_LoginForm_Login',
        });
    });
    
    $("form[name='GuestRegistrationForm']").submit(function () {
        tealium_data2track.push({
            id: 'Click',
            Tracking_Type: 'hiddenaction',
            data_element_id: 'X_X_RegisterForm_Register',
        });

        if ($('#profilingConsent').prop('checked') && wcs_config.earlyAccessActive === 'true') {
            $.cookie('eaactivity', true, { expires: 15 });
            sessionStorage.setItem('promoCodeToApplyEvaluateQuery', 'eaccess')
        }
	});
		
	if ($("#wcs-account-edit-form").length) {
		//Redirect to pdp private sale for desktop version
		var fbRtnurlPdpPrivatesale = $.cookie("fb_trnurl_pdp_privatesale");
		if (fbRtnurlPdpPrivatesale !== undefined) {
			$.removeCookie("fb_trnurl_pdp_privatesale", { path: '/' });
			window.location.href = fbRtnurlPdpPrivatesale;
		}
	}

    $("form[name='wcs-account-edit-form']").submit(function () {
        if ($('#emailSignUp').prop('checked')) {
            $.cookie('utagdata_override_emailoptin', 1);
        } else {
            $.cookie('utagdata_override_emailoptin', 0);
        }
    });

    if ($("#pageName").val() === "ViewOrder" || $("#pageName").val() === "MyOrders") {
        $("#printLabel").on("click", function (e) {
            display_center_1($("#wcs-print_UPS_label"));
            $("#wcs-print_UPS_label").css("display", "block");
            $(".wcs-fadeout-full").css("height", $(document).height());
            const rmaid = $(this).closest("div").find("input[name='RMAId']").val();
            $("#ups_form_" + rmaid).submit();
        })
    }
});

function  closeModaAddAddress(){
    $("form#delivery_information_form_add div.rb-fieldrow").each(function(){
        $(this).removeClass('rb-validrow'); 
       });
      $('.wcs-close-btn').click();
}
